import { getDecryptedName } from "../../../helpers/bycrypt";

export enum CreateEstimationStepsEnum {
  CUSTOMER_DETAILS = "customer-details",
  STORAGE_TYPE = "storage-types",
  FLOOR_DETAILS = "floor-details",
  SERVICES = "services",
  DELIVERY = "delivery-location",
  NOTES = "notes",
  DESIGN = "designs",
  SITE_SURVEY = "site-survey",
  REVIEW = "review",
}

export enum EstimationStatus {
  DRAFT = "draft",
  SAVED = "saved",
  SENT = "sent",
  APPROVED = "approved",
  DECLINED = "declined",
  SITE_SURVEY_PENDING = "site-survey-pending",
  PENDING_MANUFACTURING_QUOTE = "pending-manufacturing-quote",
  DESIGN_APPROVAL_REQUIRE = "design-approval-require",
  READY_FOR_QUOTE = "ready-for-quote",
  QUOTE_CREATED = "quote-created",
}

export const EstimationStatusLabels: Record<EstimationStatus, string> = {
  [EstimationStatus.DRAFT]: "Draft",
  [EstimationStatus.SAVED]: "Saved",
  [EstimationStatus.SENT]: "Sent",
  [EstimationStatus.APPROVED]: "Site survey Required",
  [EstimationStatus.DECLINED]: "Declined",
  [EstimationStatus.SITE_SURVEY_PENDING]: "Site Survey Pending",
  [EstimationStatus.PENDING_MANUFACTURING_QUOTE]: "Pending Manufacturing Quote",
  [EstimationStatus.DESIGN_APPROVAL_REQUIRE]: "Design Approval Required",
  [EstimationStatus.READY_FOR_QUOTE]: "Ready For Quote",
  [EstimationStatus.QUOTE_CREATED]: "Quote Created",
};

export const EstimationStatusColors: Record<EstimationStatus, string> = {
  [EstimationStatus.DRAFT]: "default",
  [EstimationStatus.SAVED]: "warning",
  [EstimationStatus.SENT]: "processing",
  [EstimationStatus.APPROVED]: "success",
  [EstimationStatus.DECLINED]: "error",
  [EstimationStatus.SITE_SURVEY_PENDING]: "cyan",
  [EstimationStatus.PENDING_MANUFACTURING_QUOTE]: "magenta",
  [EstimationStatus.DESIGN_APPROVAL_REQUIRE]: "purple",
  [EstimationStatus.READY_FOR_QUOTE]: "geekblue",
  [EstimationStatus.QUOTE_CREATED]: "success",
};

export const getEstimationStatusOptions = () => {
  return Object.values(EstimationStatus).map((value) => ({
    label: EstimationStatusLabels[value],
    value: value,
  }));
};

export const getFormattedEstimationStatusLabel = (
  status: string,
  siteSurveyBy?: string | null,
): string => {
  const displayLabel = EstimationStatusLabels[status as EstimationStatus] || status;
  if (status === "site-survey-pending") {
    const surveyor = siteSurveyBy === "sm-team"
      ? `Sperrin Metal`
      : siteSurveyBy === "bradfield"
        ? "Bradfield"
        : "";
    if (surveyor) {
      return `${displayLabel} (${surveyor})`;
    }
  }
  return displayLabel;
};

export const ESTIMATION_SCROLL_KEY = "estimations_scroll_top";
export const ESTIMATION_FILTER_KEY = "estimations_filters";
export const ESTIMATION_REFETCH_KEY = "estimations_needs_refetch";

export enum WarningSeverity {
  BLOCKING = "BLOCKING",
  BYPASSABLE = "BYPASSABLE",
}

export const getShareLinkInfo = (status: string, id: string, baseUrl: string) => {
  const statusStr = (status || "").toString().toLowerCase();

  if (
    statusStr === EstimationStatus.APPROVED ||
    statusStr === EstimationStatus.SITE_SURVEY_PENDING ||
    statusStr === "site-survey-pending" ||
    statusStr === "site_survey_pending"
  ) {
    return {
      label: "Share Site Survey Link",
      url: `${baseUrl}/survey-details/${id}?status=site_survey_pending`,
      successMessage: "Site survey link copied to clipboard!",
    };
  }

  if (
    statusStr === EstimationStatus.PENDING_MANUFACTURING_QUOTE ||
    statusStr === "pending-manufacturing-quote" ||
    statusStr === "pending_manufacturing_quote"
  ) {
    return {
      label: "Share Quote Link",
      url: `${baseUrl}/survey-details/${id}?status=pending_manufacturing_quote`,
      successMessage: "Quote link copied to clipboard!",
    };
  }

  return {
    label: "Share Approval Link",
    url: `${baseUrl}/estimate-details/${id}`,
    successMessage: "Approval link copied to clipboard!",
  };
};